module.exports = __webpack_public_path__ + "dash_20_app_assets/img/dfyfbl.8789c2c0.png";